<template>
  <el-drawer
  title="Filtres"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form label-position="top">
      <el-form-item>
        <el-button @click="resetProductFilters" size="mini">Remettre les filtres d'origine</el-button>
      </el-form-item>
      <el-collapse v-model="activeName" >
      <el-collapse-item title="Général" name="1">
        <el-form-item>
          <el-radio-group v-model="productActive">
            <el-radio-button label="1">Actif</el-radio-button>
            <el-radio-button label="0">Inactif</el-radio-button>
            <el-radio-button label="2">Tous</el-radio-button>
          </el-radio-group>
        </el-switch>
      </el-form-item>
        <el-form-item>
          <el-radio-group v-model="productPublished">
            <el-radio-button label="1">Publié</el-radio-button>
            <el-radio-button label="0">Non publié</el-radio-button>
            <el-radio-button label="2">Tous</el-radio-button>
          </el-radio-group>
        </el-switch>
      </el-form-item>
      </el-collapse-item>
        <el-collapse-item title="Étiquettes" name="2">
          <el-form-item>
             <el-checkbox-group  v-model="checkedTags" >
               <el-row v-for="tag in listTags" :key="tag.id">
                 <el-col>
                   <el-checkbox :label="tag.id" style="margin-left:0px;">{{tag.code}}</el-checkbox>
                 </el-col>
               </el-row>
             </el-checkbox-group>
           </el-form-item>
        </el-collapse-item>
      <template v-if="isCMS">
        <el-collapse-item title="Compagnies" name="3">
          <el-form-item>
            <el-select v-model="cmsPortausCompanyIds" multiple placeholder="Toutes" clearable style="width:100%">
              <el-option v-for="pc in allPortausCompanies" :key="pc.id" :label="pc.name" :value="pc.id"></el-option>
            </el-select>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Image principale" name="4">
          <el-form-item>
            <el-select v-model="cmsHasMainImage" placeholder="Toutes" clearable style="width:100%">
              <el-option label="Avec image" :value="true"></el-option>
              <el-option label="Sans image" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Type de vin" name="5">
          <el-form-item label="Type">
            <el-select v-model="cmsTypeId" placeholder="Tous" clearable style="width:100%" @change="onTypeChange">
              <el-option v-for="t in productTypes" :key="t.id" :label="t.name && (t.name.fr || t.name.en) || t.code" :value="t.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sous-type" v-if="cmsTypeId != null">
            <el-select v-model="cmsSpecificTypeId" placeholder="Tous" clearable style="width:100%">
              <el-option v-for="t in filteredSpecificTypes" :key="t.id" :label="t.name && (t.name.fr || t.name.en) || t.code" :value="t.id"></el-option>
            </el-select>
          </el-form-item>
        </el-collapse-item>
      </template>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import productAPI from '@/services/API/product'
import cmsAPI from '@/services/API/cmsAPI'
import moment from 'moment';

export default {
  name: 'product-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : ['1'],
      productTypes: [],
      specificProductTypes: [],
    };
  },components: {

  },
  watch : {

  },
	methods: {
    emitFiltersChange() {
      this.$emit('filtersChange', {
        activeFilters: this.activeFilters,
        filters: {
          tags: this.productFilters.checkedTags,
          productsAvailabilityInd: this.productsAvailabilityInd,
          productPublished: this.productPublished,
          productPublished: this.productPublished,
        }
      }) ;
    },
    open(){
      this.fetchTags();
      if (this.isCMS) {
        cmsAPI.fetchProductTypes().then(types => { this.productTypes = types || []; });
        cmsAPI.fetchProductSpecificTypes().then(types => { this.specificProductTypes = types || []; });
      }
    },
    onTypeChange() {
      this.setCmsSpecificTypeId(null);
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('products',['fetchTags', 'setProductPublishedInd', 'resetProductFilters', 'setCheckedProductsTags', 'setActiveFilter', 'setCmsPortausCompanyIds', 'setCmsHasMainImage', 'setCmsTypeId', 'setCmsSpecificTypeId']),
	},
  watch: {
    // whenever question changes, this function will run
    checkedTags() {
        this.emitFiltersChange();
    },
    productPublished () {
      this.emitFiltersChange();
    },
    cmsPortausCompanyIds () {
      this.emitFiltersChange();
    },
    cmsHasMainImage () {
      this.emitFiltersChange();
    },
    cmsTypeId () {
      this.emitFiltersChange();
    },
    cmsSpecificTypeId () {
      this.emitFiltersChange();
    },
  },
	computed: {
    isCMS () {
      return this.$store.state.products.origin === 'CMS';
    },
    allPortausCompanies () {
      return this.$store.state.controlData.portausCompanies || [];
    },
    filteredSpecificTypes () {
      if (this.cmsTypeId == null) return [];
      return this.specificProductTypes.filter(t => _.get(t, 'productType.id') === this.cmsTypeId);
    },
    activeFilters () {
      let nbActive = 0;
      if(this.productsAvailabilityInd != null) nbActive++;
      if(this.productPublished != 2) nbActive++;
      if(this.productFilters.checkedTags.length>0) nbActive += this.productFilters.checkedTags.length;
      if (this.isCMS) {
        if (this.productFilters.cmsPortausCompanyIds && this.productFilters.cmsPortausCompanyIds.length > 0) nbActive++;
        if (this.productFilters.cmsHasMainImage != null) nbActive++;
        if (this.productFilters.cmsTypeId != null) nbActive++;
        if (this.productFilters.cmsSpecificTypeId != null) nbActive++;
      }
      return nbActive;
    },
		checkedTags : {
			set(val){
        this.setCheckedProductsTags(val);
      },
			get(){return this.getFilterCheckedTags}
		},
    productPublished : {
      set(productPublished){
        this.setProductPublishedInd(productPublished);
      },
			get(){return this.getFilterPublishedInd }
    },
    productActive : {
      set(ind){
        this.setActiveFilter(ind);
      },
      get(){return this.getFilterProductActive }
    },
    cmsPortausCompanyIds: {
      set(val) { this.setCmsPortausCompanyIds(val); },
      get() { return this.productFilters.cmsPortausCompanyIds || []; }
    },
    cmsHasMainImage: {
      set(val) { this.setCmsHasMainImage(val); },
      get() { return this.productFilters.cmsHasMainImage; }
    },
    cmsTypeId: {
      set(val) { this.setCmsTypeId(val); },
      get() { return this.productFilters.cmsTypeId; }
    },
    cmsSpecificTypeId: {
      set(val) { this.setCmsSpecificTypeId(val); },
      get() { return this.productFilters.cmsSpecificTypeId; }
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('products',['listTags', 'productFilters']),
    ...mapGetters('products', ['getFilterPublishedInd', 'getFilterCheckedTags', 'getFilterProductActive'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
